import { Trans } from '@lingui/react'
import { bool, func, shape } from 'prop-types'

import { TENANT_AT, TENANT_COM } from 'shared/consts/tenants'
import noop from 'shared/utils/noop'
import IconRedpoints from 'views/components/atoms/Icon/IconRedpoints'
import OffCanvasItem from 'views/components/organisms/OffCanvas/OffCanvasItem'
import OffCanvasItemList from 'views/components/organisms/OffCanvas/OffCanvasItemList'
import Tenant from 'views/components/utils/Tenant'
import withMountPoints from 'views/enhancers/withMountPoints'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { isRedPointsActive } from 'views/utils/featureToggleUtils'
import { mountPointsType, offCanvasCategory } from 'views/utils/propTypes'

const OffCanvasTopLinks = ({
  userLoggedIn,
  subscriptionService,
  data,
  goNextHandler,
  ghosts,
  mountPoints,
  publicRuntimeConfig: {
    pageProperties: { featureToggles },
  },
}) => {
  const redPointsToggleIsActive = isRedPointsActive(featureToggles)

  return (
    <ul className="a-list-reset">
      {!userLoggedIn ? (
        <li className="o-OffCanvas__OffCanvasTopLinks__login">
          <OffCanvasItem href={mountPoints.getLogin()} name="off-canvas-login">
            <Trans id="offcanvas.link.loginOrRegister" />
          </OffCanvasItem>
        </li>
      ) : (
        <>
          <li>
            <OffCanvasItem
              href={mountPoints.getUserAccount()}
              name="off-canvas-login"
            >
              <Trans id="offcanvas.link.myApotheke" />
            </OffCanvasItem>
          </li>
          {subscriptionService && (
            <li data-clientside-hook="headerAboLink" aria-hidden>
              <OffCanvasItem href={mountPoints.getAccountSubscriptions()}>
                <Trans id="menubar.AccountFlyout.link.myAbos" />
              </OffCanvasItem>
            </li>
          )}
        </>
      )}

      {data && (
        <li>
          <OffCanvasItemList {...{ data, goNextHandler, ghosts }} />
        </li>
      )}

      {redPointsToggleIsActive && (
        <Tenant tenant={[TENANT_AT, TENANT_COM]}>
          {() => (
            <li>
              <OffCanvasItem
                href="/redpoints-promotions/"
                name="off-canvas-redpoints"
              >
                <span>
                  <IconRedpoints className="u-margin-xx-small--right u-color--red o-OffCanvas__OffCanvasTopLinks__redpoints-icon" />
                  <Trans id="main.menu.rpPromotions" />
                </span>
              </OffCanvasItem>
            </li>
          )}
        </Tenant>
      )}
    </ul>
  )
}

OffCanvasTopLinks.propTypes = {
  mountPoints: mountPointsType.isRequired,
  data: offCanvasCategory,
  userLoggedIn: bool,
  ghosts: bool,
  goNextHandler: func,
  subscriptionService: bool,
  publicRuntimeConfig: shape({}),
}

OffCanvasTopLinks.defaultProps = {
  data: null,
  userLoggedIn: false,
  subscriptionService: false,
  ghosts: false,
  goNextHandler: () => noop,
  publicRuntimeConfig: {},
}

export default withMountPoints(withShopAndRuntimeConfig(OffCanvasTopLinks))
